import { Pipe, PipeTransform } from '@angular/core';
import {CompetitorResultsDetail, FINISH_CONTROL_POINT_TYPE} from "@model";

@Pipe({
    name: 'nmControlPointsOrLaps',
    standalone: false
})
export class NumberOfControlPointsOrLapsPipe implements PipeTransform {

  transform(competitorResultsDetail: CompetitorResultsDetail|undefined, isRoundRace: boolean = false): string {
    if (!competitorResultsDetail) {
      return '-';
    } else if (isRoundRace) {
      return this.getNumberOfLaps(competitorResultsDetail);
    } else {
      return this.getNumberOfControlPoints(competitorResultsDetail);
    }
  }

  private getNumberOfControlPoints(competitorResultsDetail: CompetitorResultsDetail) {
    if (competitorResultsDetail?.fn_cp !== undefined && competitorResultsDetail?.fn_cp > 0) {
      return competitorResultsDetail.fn_cp.toString();
    } else if (competitorResultsDetail.SGS != null && Object.keys(competitorResultsDetail.SGS).length > 0
      && Object.values(competitorResultsDetail.SGS).filter((item) => item.tp !== FINISH_CONTROL_POINT_TYPE && item.includedInRanking).length > 0) {
      return Object.values(competitorResultsDetail.SGS).filter((item) => item.tp !== FINISH_CONTROL_POINT_TYPE && item.includedInRanking).length.toString();
    } else {
      return '-';
    }
  }

  private getNumberOfLaps(competitorResultsDetail: CompetitorResultsDetail) {
    if (competitorResultsDetail?.tl_lp !== undefined && competitorResultsDetail?.tl_lp > 0) {
      return competitorResultsDetail.tl_lp.toString();
    } else if (competitorResultsDetail.laps != null && Object.values(competitorResultsDetail.laps).length > 0) {
      return Object.values(competitorResultsDetail.laps).length.toString();
    } else {
      return '-';
    }
  }
}
